import React from 'react';
import { Stack, SvgIcon } from '@mui/material';

export const IconText = ({ Icon, children }: { Icon: typeof SvgIcon; children: React.ReactNode }) => (
  <Stack direction='row' gap={1} sx={{ alignItems: 'center' }}>
    <Icon />
    {children}
  </Stack>
);
